import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}


// Business runs on Pacific time — punches always display in it, whatever the device's zone.
export const PACIFIC_TZ = "America/Los_Angeles";

const pacificParts = (t) => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: PACIFIC_TZ, hourCycle: "h23", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit",
  }).formatToParts(new Date(t));
  return Object.fromEntries(parts.map((p) => [p.type, p.value]));
};

/** ISO → "9:12 AM" in Pacific. */
export const fmtPacificTime = (iso) =>
  new Date(iso).toLocaleTimeString("en-US", { timeZone: PACIFIC_TZ, hour: "numeric", minute: "2-digit" });

/** ISO → "10/22/2026, 9:12:00 AM" in Pacific. */
export const fmtPacificDateTime = (iso, opts = {}) => new Date(iso).toLocaleString("en-US", { timeZone: PACIFIC_TZ, ...opts });

/** ISO → "2026-10-22" (the Pacific calendar day). */
export const pacificDay = (iso) => new Date(iso).toLocaleDateString("en-CA", { timeZone: PACIFIC_TZ });

/** ISO → "YYYY-MM-DDTHH:mm" Pacific wall time, for datetime-local inputs. */
export const toPacificInput = (iso) => {
  if (!iso) return "";
  const p = pacificParts(iso);
  return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}`;
};

/** datetime-local value read as Pacific wall time → UTC ISO string. */
export const fromPacificInput = (val) => {
  const [d, t] = val.split("T");
  const [y, mo, da] = d.split("-").map(Number);
  const [h, mi] = t.split(":").map(Number);
  const wall = Date.UTC(y, mo - 1, da, h, mi);
  const offset = (ms) => {
    const p = pacificParts(ms);
    return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second) - Math.floor(ms / 1000) * 1000;
  };
  return new Date(wall - offset(wall - offset(wall))).toISOString();
};

/** "2026-08-24" or ISO datetime → "08/24/2026" (display only; storage stays ISO). */
export const fmtDate = (iso) => {
  if (!iso) return "";
  // a full timestamp (with its zone) shows the Pacific calendar day, not the UTC one
  const s = /T\d{2}:\d{2}.*(Z|[+-]\d{2}:?\d{2})$/.test(String(iso)) ? pacificDay(iso) : String(iso);
  const [y, m, d] = s.slice(0, 10).split("-");
  return y && m && d ? `${m}/${d}/${y}` : String(iso);
};
